import { render, staticRenderFns } from "./html-content.vue?vue&type=template&id=1fcb3e7e"
import script from "./html-content.vue?vue&type=script&lang=js"
export * from "./html-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports